module.exports = __webpack_public_path__ + "static/media/stockhausen_mainz_23.fd111483.jpg";